{
  "achievement-center": "Achievement Center",
  "admin": "Admin Panel",
  "admin-learn": "Admin Learn & Earn",
  "admin-p2p": "Admin P2P",
  "admin-referrals": "Admin Referrals",
  "admin-rewards": "Admin Rewards",
  "ai-arbitrage-scanner": "AI Arbitrage Scanner",
  "ai-assistant": "AI Trading Assistant",
  "ai-copy-trading": "AI Copy Trading",
  "ai-grid-trading": "AI Grid Trading",
  "ai-launchpad": "AI Launchpad",
  "ai-market-scanner": "AI Market Scanner",
  "ai-news": "AI News",
  "ai-portfolio": "AI Portfolio Manager",
  "ai-profit-calculator": "AI Profit Calculator",
  "ai-risk-manager": "AI Risk Manager",
  "ai-smart-alerts": "AI Smart Alerts",
  "ai-trust-score": "AI Trust Score",
  "ai-whale-alerts": "AI Whale Alerts",
  "ai-whale-heatmap": "AI Whale Heatmap",
  "ai-whale-tracker": "AI Whale Tracker",
  "buy": "Buy Crypto",
  "certificates": "My Certificates",
  "dashboard": "Dashboard",
  "exalt-utility-center": "Exalt Utility Center",
  "futures": "Futures",
  "kyc": "KYC Requests",
  "kyc-submit": "Submit KYC",
  "learnearn": "Learn & Earn",
  "listings": "Submit Listing",
  "markets": "Markets",
  "notification-center": "Notification Center",
  "orders": "Orders",
  "p2p": "P2P",
  "profile": "Profile",
  "referral": "Referral",
  "reputation-center": "Community Reputation",
  "rewards": "Rewards",
  "settings": "Settings",
  "social-trading": "Social Trading",
  "spotTrading": "Spot Trading",
  "staking": "Staking",
  "support": "Support",
  "trade": "Spot Trading",
  "transactions": "Transactions",
  "wallets": "Wallets",
  "web3wallet": "Web3 Wallet"
}